import React, { Fragment, useCallback } from 'react'
import { useInfiniteQueryChargingHistory } from '@/api/charging/queries'
import { ChargingHistory, ChargingSummary } from '@/types/Charging'
import { HistoryItem } from './HistoryItem'
import { InfiniteScrollList } from '@/components/InfiniteScrollList'
import { ListSkeleton } from '@/components/ListSkeleton'
import { ChargingSessionSummaryModal } from '@/modules/ChargingPoint/modals/ChargingSessionSummaryModal'
import { useDisclosure } from '@/hooks/useDisclosure'

export const HistoryList: React.FC = () => {
  const query = useInfiniteQueryChargingHistory()
  const chargingSummaryModal = useDisclosure<ChargingSummary>()
  const { open: openChargingSummary } = chargingSummaryModal

  const renderItem = useCallback(
    (item: ChargingHistory) => <HistoryItem historyItem={item} onClickDetails={openChargingSummary} />,
    [openChargingSummary]
  )

  const getKey = useCallback((item: ChargingHistory) => item.session_id, [])

  return (
    <Fragment>
      <InfiniteScrollList<ChargingHistory>
        query={query}
        renderItem={renderItem}
        getKey={getKey}
        skeleton={<ListSkeleton.HistoryItem />}
        spacing={2}
        emptyTitle="Nenhum resultado encontrado."
        emptyMessage="Não há recargas realizadas."
      />
      <ChargingSessionSummaryModal modalMethods={chargingSummaryModal} />
    </Fragment>
  )
}
